import { Document } from '@models/document';
import { SlugEntityAdminApiService } from './slugEntityAdminApiService';

export class DocumentAdminService extends SlugEntityAdminApiService<Document> {
    constructor() {
        super('/api/admin/document');
    }
}
